if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
        this.elements.panel.addEventListener('click', this.onItemClick.bind(this));

        if (this.elements.panel.dataset.listSection) {
          const prefetch = () => this.loadList().catch(() => {});
          ['pointerenter', 'touchstart', 'focus'].forEach((type) =>
            this.elements.button.addEventListener(type, prefetch, { once: true, passive: true })
          );
        }
      }

      loadList() {
        const section = this.elements.panel.dataset.listSection;
        if (!section) return Promise.resolve();
        if (!this.listRequest) {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          this.listRequest = fetch(`${root}?section_id=${section}`)
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((html) => {
              const list = new DOMParser().parseFromString(html, 'text/html').querySelector('ul');
              if (!list) throw new Error('empty');
              this.elements.panel.appendChild(document.adoptNode(list));
              delete this.elements.panel.dataset.listSection;
            })
            .catch((error) => {
              this.listRequest = null;
              throw error;
            });
        }
        return this.listRequest;
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if(this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        const item = event.target.closest('a[data-value]');
        if (!item) return;
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = item.dataset.value;
        if (form) form.submit();
      }

      async openSelector() {
        this.elements.button.focus();
        if (this.elements.panel.dataset.listSection) {
          if (this.opening) return;
          this.opening = true;
          try {
            await this.loadList();
          } catch (error) {
            window.location.href = this.elements.panel.dataset.fallbackUrl;
            return;
          } finally {
            this.opening = false;
          }
        }
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}
